import React from 'react'
import cx from 'classnames'
import { Link, useMatch } from 'react-router-dom'
import { Icon } from '@manychat/manyui'
import { IconNames } from '@manychat/manyui/src/components/Link/interfaces'

import cm from './NavigationLink.module.css'

interface NavigationLinkProps {
  to: string
  label: string
  icon: IconNames
}

export const NavigationLink = ({ to, label, icon }: NavigationLinkProps) => {
  const isActive = useMatch(to)

  const LinkIcon = Icon[icon]

  return (
    <Link
      to={to}
      className={cx(cm.navigationButton, isActive && cm.navigationButton_active)}
      aria-current={isActive ? 'page' : undefined}
    >
      <LinkIcon className={cm.navigationButton__icon} size={16} />

      <span>{label}</span>
    </Link>
  )
}
